import { render, staticRenderFns } from "./brandData.vue?vue&type=template&id=1593c8fe&"
import script from "./brandData.vue?vue&type=script&lang=js&"
export * from "./brandData.vue?vue&type=script&lang=js&"
import style0 from "./brandData.vue?vue&type=style&index=0&id=1593c8fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports